import { IsNotEmpty, IsNumber, IsObject, IsOptional, IsString } from 'class-validator';
import { Type } from 'class-transformer';

export class CreateLobbyPlayerDto {
	@IsString()
	@IsNotEmpty()
	firstname!: string;

	@IsString()
	@IsNotEmpty()
	lastname!: string;

	@IsOptional()
	@Type(() => Number)
	@IsNumber()
	rate?: number;

	@IsOptional()
	@IsString()
	link?: string;

	@IsOptional()
	@IsObject()
	img_variants?: Record<string, string> | null;
}
